import React, { FC } from 'react'

import { css } from '@linaria/core'
import { styled } from '@linaria/react'

import { WithDataName } from 'common/types'
import { MenuIcon } from 'components/designSystem/MenuIcon/MenuIcon'
import { FontSize } from 'components/designSystem/Typography/Typography'

import { ProfileListType } from '../Profile.types'

export const ProfileList: FC<
  {
    list?: ProfileListType[]
    fontSize?: FontSize
  } & WithDataName
> = ({ list, fontSize = 20, ...rest }) => {
  if (list && list.length > 0) {
    return (
      <List data-name={rest['data-name']}>
        {list.map(({ icon, title, ...rest }) => (
          <ListItem
            text={title}
            icon={icon}
            fontSize={fontSize}
            fontWeight={500}
            tag="li"
            key={title}
            iconStyle={iconCss}
            textStyle={textCss}
            data-name={rest['data-name']}
          />
        ))}
      </List>
    )
  }

  return null
}

const List = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: var(--spacing-12px);
  gap: var(--spacing-12px);
`

const ListItem = styled(MenuIcon)`
  align-items: flex-start;
`

const iconCss = css`
  display: flex;
  height: 28px;
  align-items: center;
  color: var(--foreground-default);
`

const textCss = css`
  color: var(--foreground-soft);
`
